import uploadshomesidebyside02image113709_n2_indd8200407e1920wWebp from "$lib/data/generated/uploads/home/SideBySide 02/image/113709_N2_indd-8200407e-1920w.webp";

export const uploads = {
  "uploads/home/SideBySide 02/image/113709_N2_indd-8200407e-1920w.webp": uploadshomesidebyside02image113709_n2_indd8200407e1920wWebp
};